/**
 * Phase 1 Home Hero media lives behind one stable contract so a future asset
 * swap does not require editing the page component. Keep the WebP poster and
 * WebM video visually aligned; the poster is always rendered first.
 */
export const SOCIAL_HOME_HERO_MEDIA = Object.freeze({
  posterSrc: '/gate-d/main-v2-poster.webp',
  videoSrc: '/gate-d/main-v2.mp4',
  videoType: 'video/mp4',
});
